import { connect } from "react-redux";
import MainPageWithMenu from "../../components/common/MainPageTemplate/mainPageWithMenu";
import SetupWizard from "../../components/tutor/setup/setupWizard";
import { useNavigate } from "react-router-dom";
import { ACCOUNT_TYPES } from "../../config/constants";

const TeachingStyle = ({ user }) => {
    const navigate = useNavigate();
    return (
        <MainPageWithMenu user={user} menuSelected={"faqs"} disableScroll={window >= 1024}>
            <div className="w-full h-full flex flex-col justify-start items-center" style={{
                height: '100% !important'
            }}>
                <div className="w-full  Title-height flex justify-center items-center p-8">
                    <h1 className="text-2xl font-bold mb-6 text-center text-white">Teaching Style Quiz</h1>
                </div>
                {
                    user.accountType === ACCOUNT_TYPES.TUTOR && <div className="bg-white rounded-lg shadow-lg p-6">
                        <SetupWizard navigate={navigate} />
                    </div>
                }
            </div>
        </MainPageWithMenu>
    );
};

const mapStateToProps = (state) => ({
    user: state.user.user,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TeachingStyle);

